<div class="askPanelChat">
  <ng-scrollbar class="askPanelChat-messages">
    <div class="askPanelChat-messages-inner">
      @if (messages().length === 0 && !loading()) {
        <div class="askPanelChat-empty">
          <p class="askPanelChat-empty-title">{{ "AskChatEmptyTitle" | translate }}</p>
          <p class="askPanelChat-empty-subtitle">{{ "AskChatEmptySubtitle" | translate }}</p>
        </div>
      }

      @for (message of messages(); track trackById($index, message)) {
        <div class="askPanelChat-row" [class.askPanelChat-row-user]="message.role === 'user'">
          @if (message.role === 'user') {
            <p class="askPanelChat-bubble askPanelChat-bubble-user">{{ message.content }}</p>
          } @else {
            <div class="askPanelChat-assistant">
              <div
                class="askPanelChat-bubble askPanelChat-bubble-assistant"
                [class.askPanelChat-bubble-error]="message.isError"
                [class.askPanelChat-bubble-refusal]="message.isRefusal"
              >
                @if (message.isError) {
                  {{ message.content }}
                } @else {
                  <markdown [data]="message.content"></markdown>
                }
              </div>
              @if (!message.isError && message.citations?.length) {
                <div class="askPanelChat-sources">
                  <span class="askPanelChat-sources-label">{{ "AskChatSourcesLabel" | translate }}</span>
                  @for (citation of message.citations; track citation.slug + citation.url) {
                    @if (citation.url) {
                      <a class="askPanelChat-source" [href]="citation.url" target="_blank" rel="noopener" dir="ltr">
                        <i-tabler name="external-link" class="icon-14 d-flex askPanelChat-source-icon"></i-tabler>
                        <span>{{ citationLabel(citation) }}</span>
                      </a>
                    } @else {
                      <!-- No url to link out to — still show the citation, as plain (non-link) text,
                           rather than silently dropping it. -->
                      <span class="askPanelChat-source askPanelChat-source-plain" dir="ltr">
                        {{ citationLabel(citation) }}
                      </span>
                    }
                  }
                </div>
              }
              @if (!message.isError) {
                <div class="askPanelChat-report">
                  @if (message.reportStatus === "sent") {
                    <span class="askPanelChat-report-sent">
                      <i-tabler name="check" class="icon-14 d-flex"></i-tabler>
                      {{ "AskChatReportSent" | translate }}
                    </span>
                  } @else {
                    <button type="button" class="askPanelChat-report-toggle" (click)="toggleReport(message)">
                      <i-tabler name="flag" class="icon-14 d-flex"></i-tabler>
                      {{ "AskChatReportProblem" | translate }}
                    </button>
                    @if (message.reportStatus === "composing" || message.reportStatus === "sending" || message.reportStatus === "error") {
                      <div class="askPanelChat-report-form">
                        <input
                          type="text"
                          class="askPanelChat-report-input"
                          [ngModel]="message.reportReason ?? ''"
                          (ngModelChange)="setReportReason(message, $event)"
                          [placeholder]="'AskChatReportReasonPlaceholder' | translate"
                        />
                        <div class="askPanelChat-report-actions">
                          <button type="button" class="askPanelChat-report-cancel" (click)="toggleReport(message)">
                            {{ "AskChatReportCancel" | translate }}
                          </button>
                          <button
                            type="button"
                            class="askPanelChat-report-submit"
                            [disabled]="message.reportStatus === 'sending'"
                            (click)="submitReport(message)"
                          >
                            {{ "AskChatReportSubmit" | translate }}
                          </button>
                        </div>
                        @if (message.reportStatus === "error") {
                          <p class="askPanelChat-report-error">{{ "AskChatReportFailed" | translate }}</p>
                        }
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }

      @if (showTypingIndicator) {
        <div class="askPanelChat-row">
          <p class="askPanelChat-typing">
            <span class="askPanelChat-typing-dot"></span>
            {{ statusLabelKey | translate }}
          </p>
        </div>
      }

      <div #scrollAnchor></div>
    </div>
  </ng-scrollbar>

  @if (fatalError()) {
    <p class="askPanelChat-fatalError">{{ fatalError() }}</p>
  }

  <div class="askPanelChat-inputRow">
    <div class="askPanelChat-inputPill">
      <textarea
        #chatInput
        class="askPanelChat-input"
        rows="1"
        [ngModel]="input()"
        (ngModelChange)="input.set($event)"
        (keydown)="onKeydown($event)"
        [placeholder]="'AskChatPlaceholder' | translate"
      ></textarea>
      <button
        type="button"
        class="askPanelChat-send"
        (click)="send()"
        [disabled]="loading() || !input().trim()"
        [attr.aria-label]="'AskChatSend' | translate"
        matTooltip="{{ 'AskChatSend' | translate }}"
      >
        @if (loading()) {
          <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
        } @else {
          <i-tabler name="send" class="icon-18 d-flex"></i-tabler>
        }
      </button>
    </div>
  </div>
</div>
